export enum ParticipateInRanging { // Участвует в ранжировании
  NOT_DETERMINED = 0, // Не определено
  YES = 1,            // Да
  NO = 2,             // Нет
}



// WEBPACK FOOTER //
// ./src/app/common/enums/participate-in-ranging.enum.ts